import { IMedicalOrder, IMedicalOrderPosition } from '@alberta/konexi-shared';

export class MedicalOrderViewModel implements IMedicalOrder {
  constructor() {}
  medicalOrderHeaderText: string;
  outboundDate: string;
  middleTexts: string[];
  positions: IMedicalOrderPosition[];
}
